import { render, staticRenderFns } from "./MaterialDataModal.vue?vue&type=template&id=17731662&scoped=true&"
import script from "./MaterialDataModal.vue?vue&type=script&lang=js&"
export * from "./MaterialDataModal.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDataModal.vue?vue&type=style&index=0&id=17731662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17731662",
  null
  
)

export default component.exports